import React from "react";

const LANGUAGE_ICON_STYLES = {
  vi: {
    label: "VI",
    background: "linear-gradient(135deg, #dc2626, #991b1b)",
    color: "#fef3c7",
    borderColor: "rgba(254, 202, 202, 0.45)",
  },
  en: {
    label: "EN",
    background: "linear-gradient(135deg, #1d4ed8, #b91c1c)",
    color: "#ffffff",
    borderColor: "rgba(191, 219, 254, 0.45)",
  },
  zh: {
    label: "ZH",
    background: "linear-gradient(135deg, #b91c1c, #f59e0b)",
    color: "#fff7ed",
    borderColor: "rgba(253, 230, 138, 0.5)",
  },
  ja: {
    label: "JA",
    background: "linear-gradient(135deg, #f8fafc, #e2e8f0)",
    color: "#be123c",
    borderColor: "rgba(148, 163, 184, 0.5)",
  },
  ko: {
    label: "KO",
    background: "linear-gradient(135deg, #f8fafc, #1d4ed8)",
    color: "#be123c",
    borderColor: "rgba(148, 163, 184, 0.5)",
  },
  th: {
    label: "TH",
    background: "linear-gradient(135deg, #b91c1c, #1e3a8a)",
    color: "#ffffff",
    borderColor: "rgba(191, 219, 254, 0.45)",
  },
  id: {
    label: "ID",
    background: "linear-gradient(135deg, #dc2626 0%, #dc2626 48%, #f8fafc 52%, #e2e8f0 100%)",
    color: "#111827",
    borderColor: "rgba(148, 163, 184, 0.45)",
  },
  ms: {
    label: "MS",
    background: "linear-gradient(135deg, #1d4ed8, #dc2626)",
    color: "#fef3c7",
    borderColor: "rgba(253, 230, 138, 0.45)",
  },
};

const SIZE_STYLES = {
  sm: { width: 24, height: 18, borderRadius: 6, fontSize: 10 },
  md: { width: 30, height: 22, borderRadius: 7, fontSize: 11 },
  lg: { width: 36, height: 26, borderRadius: 8, fontSize: 12 },
};

const normalizeLanguageCode = (code) => {
  if (!code) return "vi";
  const normalized = code.toLowerCase();
  if (normalized.startsWith("zh")) return "zh";
  if (normalized.startsWith("en")) return "en";
  return normalized.split("-")[0];
};

const StableLanguageIcon = ({ code, label, size = "md", className = "" }) => {
  const languageCode = normalizeLanguageCode(code);
  const iconStyle = LANGUAGE_ICON_STYLES[languageCode] || LANGUAGE_ICON_STYLES.vi;
  const sizeStyle = SIZE_STYLES[size] || SIZE_STYLES.md;

  return (
    <span
      aria-label={label || iconStyle.label}
      title={label || iconStyle.label}
      className={className}
      style={{
        ...sizeStyle,
        alignItems: "center",
        background: iconStyle.background,
        boxShadow: `inset 0 0 0 1px ${iconStyle.borderColor}, 0 1px 2px rgba(15, 23, 42, 0.16)`,
        color: iconStyle.color,
        display: "inline-flex",
        flexShrink: 0,
        fontFamily:
          "Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
        fontWeight: 800,
        justifyContent: "center",
        letterSpacing: 0,
        lineHeight: 1,
      }}
    >
      {iconStyle.label}
    </span>
  );
};

export default StableLanguageIcon;
